import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { MobileOrderCardWrapper, RelativeWrapper, MobileOrderBackgroundCardWrapper, ColumnWrapper, Mt1, Mt3 } from 'wrappers';
import { Category, CompletionTime, OrderInfo } from './molecules';
import { Icon, SecondaryTextXs } from 'atoms';
import { UserSvg, HammerSvg, LockSvg, DocumentSvg, CloseSquareSvg } from 'components/icons';
import React from 'react';

export const definition = {
  name: 'WorkOrderTableRowMobile',
  controller: Controller,
  initialProps: ({ order, selectedTab, properties }) => ({ order, selectedTab, properties, ref: React.createRef(), swipe: 0 }),
  props: internalState,
  elements: [
    {
      wrapper: MobileOrderCardWrapper,
      name: 'WorkOrderCard',
      ref: ({ ref }) => ref,
      displayState: ({ swipe, selectedTab }) => ({ swipe: selectedTab === 'recurring' ? 0 : swipe }),
      isButton: true,
      bindings: ({ }) => ({}),
      elements: [
        {
          component: Category,
          name: 'Category',
          bindings: ({ order, properties, selectedTab }) => ({ order, propertyIcon: properties.find(p => p.id === order.property_id)?.icon, selectedTab }),
        },
        {
          component: wrap(OrderInfo, Mt3),
          name: 'OrderInfo',
          bindings: ({ order, selectedTab }) => ({ order, selectedTab }),
        },
        {
          component: wrap(CompletionTime, Mt3),
          name: 'CompletionTime',
          bindings: ({ order, selectedTab }) => ({ order, selectedTab }),
        },
      ]
    },
    {
      wrapper: MobileOrderBackgroundCardWrapper,
      name: 'BackgroundContainer',
      renderIf: ({ swipe }) => swipe !== 0,
      elements: [
        {
          wrapper: ColumnWrapper,
          isButton: true,
          name: 'Assign',
          renderIf: ({ selectedTab }) => selectedTab === 'unassigned',
          bindings: ({ }) => ({}),
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => UserSvg({ width: 20, height: 20, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: wrap(SecondaryTextXs, Mt1),
              name: 'Text',
              displayValue: ({ }) => 'Assign'
            }
          ]
        },
        {
          wrapper: ColumnWrapper,
          isButton: true,
          name: 'Unassign',
          renderIf: ({ selectedTab }) => selectedTab === 'assigned',
          bindings: ({ }) => ({}),
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => UserSvg({ width: 20, height: 20, color: window?.settings?.primary_color ?? '#1DBD6B', canceled: true })
            },
            {
              component: wrap(SecondaryTextXs, Mt1),
              name: 'Text',
              displayValue: ({ }) => 'Unassign'
            }
          ]
        },
        {
          wrapper: ColumnWrapper,
          isButton: true,
          name: 'Part',
          renderIf: ({ selectedTab }) => ['unassigned', 'assigned'].includes(selectedTab),
          bindings: ({ }) => ({}),
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => HammerSvg({ width: 20, height: 20, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: wrap(SecondaryTextXs, Mt1),
              name: 'Text',
              displayValue: ({ }) => 'Need parts'
            }
          ]
        },
        {
          wrapper: ColumnWrapper,
          isButton: true,
          name: 'Access',
          renderIf: ({ selectedTab }) => ['assigned'].includes(selectedTab),
          bindings: ({ }) => ({}),
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => LockSvg({ width: 20, height: 20, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: wrap(SecondaryTextXs, Mt1),
              name: 'Text',
              displayValue: ({ }) => 'No access'
            }
          ]
        },
        {
          wrapper: ColumnWrapper,
          isButton: true,
          name: 'Cancel',
          renderIf: ({ selectedTab }) => ['unassigned', 'assigned'].includes(selectedTab),
          bindings: ({ }) => ({}),
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => CloseSquareSvg({ width: 20, height: 20, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: wrap(SecondaryTextXs, Mt1),
              name: 'Text',
              displayValue: ({ }) => 'Cancel'
            }
          ]
        },
        {
          wrapper: ColumnWrapper,
          isButton: true,
          name: 'Reopen',
          renderIf: ({ selectedTab }) => ['completed', 'cancelled'].includes(selectedTab),
          bindings: ({ }) => ({}),
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => DocumentSvg({ width: 20, height: 20, color: window?.settings?.primary_color ?? '#1DBD6B' })
            },
            {
              component: wrap(SecondaryTextXs, Mt1),
              name: 'Text',
              displayValue: ({ }) => 'Reopen'
            }
          ]
        }
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), RelativeWrapper)